import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Import your images


import service1 from '../../Assets/accessories/brushes.png'
import service2 from '../../Assets/accessories/rollers.jpg'
import service3 from '../../Assets/accessories/blades.png'

const Access = () => {
  const settings = {
    dots: false,
    speed: 500,
    slidesToShow: 3, // Show two items at a time
    slidesToScroll: 1, // Scroll two items at a time
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const services = [
  {
  img: service1,
  title: "Premium Brushes",
  subtitle: "Smooth & Precision Painting",
  description:
    "Our high-quality paint brushes are designed for smooth application, sharp edges, and excellent paint pickup. Ideal for detailed work, trims, and corners, they ensure a clean, professional finish on every surface.",
  bgClass: "yellowbg",
  link: "/accessories/brushes"
},
{
  img: service2,
  title: "Paint Rollers",
  subtitle: "Fast & Even Coverage",
  description:
    "Our durable paint rollers deliver uniform coverage with minimal splatter, making them perfect for large wall and ceiling areas. Designed for efficiency and smooth results, they help you complete painting with a flawless finish.",
  bgClass: "greenbg",
  link: "/accessories/rollers"
},
{
  img: service3,
  title: "Putty Blades",
  subtitle: "Perfect Surface Preparation",
  description:
    "Our sturdy wall putty blades are engineered for smooth spreading, leveling, and finishing of putty surfaces. Built with high-grade materials, they provide flexibility, control, and durability for professional surface preparation.",
  bgClass: "bluebg",
  link: "/accessories/putty-blades"
},

  ];

  return (

    <div>
      <Slider {...settings} className="services-slider">
        {services.map((service, index) => (
          <div
            className={`services-itemm ${index % 2 === 1 ? "padded-item" : ""
              }`}
            key={index}
          >
            <div className="service-cardd">
              <div className="service-card__imagee">
                <img src={service.img} alt={service.title} />
              </div>
              <div className={`services-card__contentt ${service.bgClass}`}>
                <h3>
                  {service.title} <span>{service.subtitle}</span>
                </h3>
                <p>{service.description}</p>
             
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>

  );
};

export default Access;
